<template>
  <RecordViewWrapper>
    <sdPageHeader title="Proyeksi Jabatan">
      <template #subTitle>
        <!-- <sdButton class="btn-add_new" size="default" type="primary">
          <router-link to="/master/proyeksi-jabatan-add"> <sdFeatherIcons type="plus" size="14" /> Tambah</router-link>
        </sdButton> -->
        <sdButton class="btn-download_template" size="default" type="secondary" @click="handleDownloadTemplate($event)">
          <sdFeatherIcons class="mr-2" type="download" size="14" /> Download Template
        </sdButton>
        <sdButton class="btn-import mr-2" size="default" type="primary">
          <router-link to="/assessment/master/proyeksi-jabatan-import">
            <sdFeatherIcons type="download" size="14" /> Import</router-link
          >
        </sdButton>
        <sdButton class="btn-export" size="default" type="primary" @click="handleExport($event)" :loading="loading">
          <sdFeatherIcons :type="loading ? 'loader' : 'upload'" :class="{ spin: loading }" size="14" />
          {{ loading ? 'Exporting...' : 'Export' }}
        </sdButton>
      </template>

      <template #buttons>
        <div class="search-container">
          <!-- <a-select
            v-model:value="formState.searchType"
            class="search-select"
            placeholder="Search by"
            :default-value="formState.searchType"
            @change="handleSearchTypeChange"
          >
            <a-select-option value="nama">Search Nama</a-select-option>
            <a-select-option value="nik">Search NIK</a-select-option>
            <a-select-option value="npwp">Search NPWP</a-select-option>
            <a-select-option value="email">Search Email</a-select-option>
          </a-select> -->
          <div class="search-box">
            <span class="search-icon">
              <sdFeatherIcons type="search" size="14" />
            </span>
            <a-input
              @input="handleInputChange"
              v-model:value.trim="formState.searchItem"
              type="text"
              name="recored-search"
              placeholder="Search Here"
              class="search-input"
            />
          </div>
        </div>
      </template>
    </sdPageHeader>

    <Main>
      <a-row :gutter="15">
        <a-col class="w-100" :md="24">
          <sdCards headless>
            <div v-if="isLoading" class="spin">
              <a-spin />
            </div>

            <div v-else>
              <TableWrapper class="table-data-view table-responsive">
                <a-table
                  :pagination="{ pageSize: 10, showSizeChanger: true }"
                  :dataSource="dataSource"
                  :columns="columns"
                >
                  <template #status="{ text }">
                    <a-tag :color="getStatusColor(text)">
                      {{ text }}
                    </a-tag>
                  </template>
                </a-table>
              </TableWrapper>
            </div>
          </sdCards>
        </a-col>
      </a-row>
    </Main>
  </RecordViewWrapper>
</template>

<script>
import { RecordViewWrapper } from '../../../../components/crud/style';
import { computed, onMounted, reactive, ref } from 'vue';
import { Main, TableWrapper } from '../../../styled';
import { useStore } from 'vuex';
import { Modal } from 'ant-design-vue';
import { getItem } from '@/utility/localStorageControl';

const ViewPage = {
  name: 'ViewPage',
  components: { RecordViewWrapper, Main, TableWrapper },
  setup() {
    const { state, dispatch } = useStore();
    const crud = computed(() => state.crud.data);
    const isLoading = computed(() => state.crud.loading);
    const profile = getItem('profile_plnbb');
    const permissions = getItem('permissions');

    const checkPermissions = permission => {
      if (profile?.roles?.[0]?.name == 'Super Admin') {
        return true;
      }

      return permissions.includes(permission);
    };

    const columns = [
      {
        title: 'Periode Assessment',
        dataIndex: 'periode_assessment',
        key: 'periode_assessment',
      },
      {
        title: 'Jabatan',
        dataIndex: 'jabatan',
        key: 'jabatan',
      },
      {
        title: 'POG',
        dataIndex: 'pog',
        key: 'pog',
        align: 'center',
      },
      {
        title: 'FTK',
        dataIndex: 'jumlah_kebutuhan',
        key: 'jumlah_kebutuhan',
        align: 'center',
      },
      {
        title: 'Terisi',
        dataIndex: 'jumlah_terisi',
        key: 'jumlah_terisi',
        align: 'center',
      },
      {
        title: 'Status',
        dataIndex: 'status',
        key: 'status',
        slots: { customRender: 'status' },
      },
      {
        title: 'Personal Area',
        dataIndex: 'personal_area',
        key: 'personal_area',
      },
      {
        title: 'Personal Sub Area',
        dataIndex: 'personal_sub_area',
        key: 'personal_sub_area',
      },
      ...(checkPermissions('update proyeksi jabatan') || checkPermissions('delete proyeksi jabatan')
        ? [
            {
              title: 'Actions',
              dataIndex: 'action',
              key: 'action',
              width: '90px',
            },
          ]
        : []),
    ];

    onMounted(() => {
      dispatch('axiosCrudGetData', 'proyeksi-jabatan2');
    });

    const handleDelete = (id, name) => {
      Modal.confirm({
        title: 'Konfirmasi',
        content: `Apakah Anda yakin ingin menghapus ${name}?`,
        okText: 'Hapus',
        cancelText: 'Batal',
        onOk: () => {
          dispatch('axiosDataDelete', {
            id,
            url: 'proyeksi-jabatan2',
            getData: () => {
              dispatch('axiosCrudGetData', 'proyeksi-jabatan');
            },
          });
        },
      });
    };

    /* const handleUnlock = (id, name) => {
      Modal.confirm({
        title: 'Konfirmasi',
        content: `Apakah Anda yakin ingin membuka kunci proyeksi jabatan ${name}?`,
        okText: 'Unlock',
        cancelText: 'Batal',
        onOk: () => {
          dispatch('axiosDataUnlockProyeksiJabatan', {
            id,
            getData: () => {
              dispatch('axiosCrudGetData', 'proyeksi-jabatan');
            },
          });
        },
      });
    }; */

    const formState = reactive({
      searchItem: '',
    });

    const getStatusColor = status => {
      switch (status.toLowerCase()) {
        case 'vacant':
          return 'blue';
        case 'partial':
          return 'orange';
        case 'filled':
          return 'green';
        default:
          return 'default';
      }
    };

    const dataSource = computed(() =>
      crud.value.length
        ? crud.value.map((data, key) => {
            const {
              id,
              periode_assessment,
              jabatan,
              pog,
              jumlah_kebutuhan,
              jumlah_terisi,
              status,
              personal_area,
              personal_sub_area,
            } = data;

            return {
              key: key + 1,
              periode_assessment: periode_assessment ? periode_assessment.nama_periode : '-',
              jabatan: jabatan || '-',
              pog: pog || '-',
              jumlah_kebutuhan: jumlah_kebutuhan || 0,
              jumlah_terisi: jumlah_terisi || 0,
              status: status || '-',
              personal_area: personal_area || '-',
              personal_sub_area: personal_sub_area || '-',
              action: (
                <div class="table-actions">
                  {checkPermissions('update proyeksi jabatan') && (
                    <router-link class="delete" to={`/master/proyeksi-jabatan-edit/${id}`}>
                      <sdFeatherIcons type="edit" size={14} title="Ubah" />
                    </router-link>
                  )}
                  &nbsp;&nbsp;&nbsp;
                  {checkPermissions('delete proyeksi jabatan') && (
                    <router-link class="delete" onClick={() => handleDelete(id, data.jabatan)} to="#">
                      <sdFeatherIcons type="trash-2" size={14} title="Hapus" />
                    </router-link>
                  )}
                </div>
              ),
            };
          })
        : [],
    );

    const handleSearch = () => {
      dispatch('axiosDataSearch', {
        url: 'proyeksi-jabatan2',
        filter: formState.searchItem,
      });
    };

    const handleInputChange = () => {
      /* if (formState.searchType === 'nik') {
        if (formState.searchItem.length === 16 || formState.searchItem.length === 0) {
          handleSearch();
        }
      } else if (formState.searchType === 'npwp') {
        if (
          formState.searchItem.length === 16 ||
          formState.searchItem.length === 0 ||
          formState.searchItem.length === 15
        ) {
          handleSearch();
        }
      } else { */
      handleSearch();
      // }
    };

    /* const handleSearchTypeChange = () => {
      formState.searchItem = '';
    }; */

    const handleDownloadTemplate = event => {
      event.preventDefault();

      dispatch('axiosDownloadTemplate', {
        url: 'download-template-proyeksi-jabatan',
        fileName: 'Template Import Proyeksi Jabatan KEEPInsight.xlsx',
      });
    };

    const loading = ref(false);

    const handleExport = () => {
      const accessToken = getItem('access_token');
      loading.value = true;

      const headers = new Headers();
      if (accessToken) {
        headers.append('Authorization', `Bearer ${accessToken}`);
      }
      headers.append('Accept', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet');
      headers.append('Content-Type', 'application/json');

      fetch(`${process.env.VUE_APP_API_ASS}/export-proyeksi-jabatan`, {
        method: 'POST',
        headers,
      })
        .then(response => {
          if (!response.ok) throw new Error('Unauthorized');
          return response.blob();
        })
        .then(blob => {
          const date = new Date();
          const offset = date.getTimezoneOffset();
          date.setMinutes(date.getMinutes() - offset);
          const filename = `proyeksi-jabatan_${date
            .toISOString()
            .replace(/[-:T.]/g, '')
            .slice(0, 14)}.xlsx`;
          const url = window.URL.createObjectURL(blob);
          const a = document.createElement('a');
          a.href = url;
          a.download = filename;
          document.body.appendChild(a);
          a.click();
          window.URL.revokeObjectURL(url);
          document.body.removeChild(a);
        })
        .catch(error => {
          // Use the imported Modal from ant-design-vue instead of ctx.root
          Modal.error({
            title: 'Export Failed',
            content: error.message,
          });
        })
        .finally(() => {
          loading.value = false;
        });
    };

    return {
      getStatusColor,
      formState,
      columns,
      isLoading,
      crud,
      dataSource,
      handleDelete,
      // handleUnlock,
      handleSearch,
      handleInputChange,
      // handleSearchTypeChange,
      handleDownloadTemplate,
      handleExport,
      checkPermissions,
      loading,
    };
  },
};

export default ViewPage;
</script>

<style scoped>
.mr-2 {
  margin-right: 0.5rem;
}

.search-container {
  display: flex;
  align-items: center;
  gap: 8px;
}

.search-select {
  width: 180px;
}

.search-box {
  display: flex;
  align-items: center;
  position: relative;
}

.search-icon {
  position: absolute;
  left: 12px;
  top: 50%;
  transform: translateY(-50%);
  z-index: 1;
}

.search-input {
  padding-left: 35px;
}
</style>
